import React from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * A wrapper around the shadcn Input that adds a small clear (×) button
 * when there is text. It expects a controlled value + onChange.
 */
const ClearableInput = ({ value, onChange, className, ...props }) => {
  const handleClear = (e) => {
    e.preventDefault();
    if (onChange) {
      // Simulate a normal input change event shape
      onChange({ target: { value: "" } });
    }
  };

  const hasValue = typeof value === "string" && value.length > 0;

  return (
    <div className="relative">
      <Input
        value={value}
        onChange={onChange}
        className={cn("pr-8", className)}
        {...props}
      />
      {hasValue && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute inset-y-0 right-0 flex items-center pr-2 text-slate-400 hover:text-slate-600"
          aria-label="Clear input"
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </div>
  );
};

export default ClearableInput;
